import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export default function useSearchParams() {
  const { search } = useLocation();
  const navigate = useNavigate();

  const searchParams = React.useMemo(() => new URLSearchParams(search), [search]);

  const setSearchParams = React.useCallback(
    (_searchParams) => {
      navigate({ search: _searchParams.toString() });
    },
    [navigate],
  );

  return [searchParams, setSearchParams];
}
